import React from "react";
import CrmEmpty from "../CrmEmpty";
import { Table, Spin, Descriptions } from "antd";
import StringHelper from '../../../helpers/StringHelper';
import moment from 'moment-jalaali';
import strings from '../../../../utils/strings';
import { useReportsStore } from "../../../../store/slices/createReportsSlice";

export default function CrmWallet() {
    const reports = useReportsStore()
    const transactions = reports.crmWallet.data.Transactions;
    const Balance = reports.crmWallet.data.Balance;
    const initialloading = reports.crmWallet.loading;

    const columns = [

        {
            title: 'کد',
            dataIndex: 'PaymentId',
            width: 100,
            render: (text) => StringHelper.getFarsiNum(text)
        },

        {
            title: 'عنوان',
            dataIndex: 'WalletTitle',
            width: 130,
            key: 'WalletTitle',
            render: text => strings.getFarsiNum(text),
        },
        {
            title: "نام بیزینس",
            dataIndex: 'BusinessName',
            width: 130,
            key: 'BusinessName',
            render: text => strings.getFarsiNum(text),
        },
        {
            title: 'مبلغ(ریال)',
            dataIndex: 'Amount',
            key: 'Amount',
            width: 100,
            render: data => data && strings.currencyFormat(data) + ' ریال',
        },
        {
            title: 'مانده پس از تراکنش',
            dataIndex: 'Balance',
            key: 'Balance',
            width: 100,
            render: data => data && strings.currencyFormat(data) + ' ریال',
        },        
        {
            title: 'تاریخ ثبت',
            dataIndex: 'CreateTime',
            key: 'CreateTime',
            width: 140,
            render: data => data && strings.getFarsiNum(moment(data).format('jYYYY/jMM/jDD  ساعت:  HH:mm  '))
        },
        {
            title: "توضیحات",
            dataIndex: "Description",
            width: 300,
            key: "Description",
            render: text => <span style={{ color: '#5ec393' }}>{text}</span>,
        },

    ];



    return (
        <Spin spinning={initialloading}>
            {Balance?.Balance &&
                <div className="user-report" style={{ marginTop: "10px" }} >
                    <Descriptions >
                        <Descriptions.Item label=" مانده کیف پول">{strings.currencyFormat(Balance?.Balance)}&nbsp;ریال</Descriptions.Item>
                    </Descriptions>
                </div>}
            {transactions ?
                <Table
                    style={{ overflowX: 'scroll', width: "100%" }}
                    className="custom-table crm-request-report"
                    showHeader={true}
                    columns={columns}
                    loading={initialloading}
                    scroll={true}
                    pagination={true}
                    dataSource={transactions}
                    rowKey="PaymentId"

                />
                :
                <CrmEmpty text="کیف پول یافت نشد" />}
        </Spin>
    );
}
